import { TDocFile, TDocProject } from 'shared/constants/docs';
import { isDocumentShared } from 'shared/_model/sharing/utils';
import { ColoredIcon, IconShare } from 'shared/_ui/icon';
import { SharingType } from 'shared/_model/sharing/types';

type DocumentShareIconProps =
	| { type: SharingType.FILE; sharing: TDocFile['sharing'] }
	| { type: SharingType.PROJECT; sharing: TDocProject['sharing'] };

export default function DocumentShareIcon({ sharing, type }: DocumentShareIconProps) {
	const color = isDocumentShared(sharing, type) ? 'success' : 'disabled';
	return <ColoredIcon Component={IconShare} color={color} />;
}
